<template>
  <div class="admin-room-container figma-property-page">
    <div class="figma-white-card">
      <div class="figma-page-header">
        <div class="figma-page-title">{{ $t('committeeQuestionnaireTopic.pageTitle') }}</div>
        <div class="figma-header-divider"></div>
        <div class="figma-header-row">
          <div class="figma-btn-group">
            <el-button size="small" class="figma-btn-add" @click="handleAdd">
              <i class="el-icon-plus"></i>{{ $t('committeeQuestionnaireTopic.action.add') }}
            </el-button>
            <el-button size="small" class="figma-btn-refresh" title="刷新" @click="getList">
              <i class="el-icon-refresh-right"></i>
            </el-button>
          </div>
          <div class="figma-search-group">
            <el-input size="small" v-model="conditions.keyword" :placeholder="$t('committeeQuestionnaireTopic.search.keywordPlaceholder')" class="figma-search-input" clearable @keyup.enter.native="handleSearch" />
            <el-button size="small" class="figma-btn-search" @click="handleSearch">
              <i class="el-icon-search"></i>搜索
            </el-button>
          </div>
        </div>
      </div>

      <div class="figma-table-section">
        <el-table v-loading="loading" :data="tableData" style="width: 100%" :header-cell-style="headerCellStyle" :cell-style="cellStyle">
          <el-table-column prop="communityName" :label="$t('committeeQuestionnaireTopic.table.communityName')" min-width="132" show-overflow-tooltip />
          <el-table-column prop="topicName" :label="$t('committeeQuestionnaireTopic.table.name')" min-width="174" show-overflow-tooltip />
          <el-table-column prop="topicTypeName" :label="$t('committeeQuestionnaireTopic.table.type')" min-width="143" show-overflow-tooltip />
          <el-table-column prop="optionsText" :label="$t('committeeQuestionnaireTopic.table.options')" min-width="400" show-overflow-tooltip />
          <el-table-column prop="createTime" :label="$t('committeeQuestionnaireTopic.table.createTime')" min-width="194" show-overflow-tooltip />
          <el-table-column :label="$t('committeeQuestionnaireTopic.table.action')" min-width="124" align="center">
            <template slot-scope="scope">
              <div class="action-links">
                <el-button type="text" size="small" @click="handleEdit(scope.row)">{{ $t('committeeQuestionnaireTopic.action.edit') }}</el-button>
                <el-button type="text" size="small" class="delete-btn" @click="handleDelete(scope.row)">{{ $t('committeeQuestionnaireTopic.action.delete') }}</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="figma-pagination-section">
        <el-pagination background layout="total, prev, pager, next, sizes" :total="pagination.total" :current-page="pagination.page" :page-size="pagination.row" :page-sizes="[10, 20, 50]" @current-change="handlePageChange" @size-change="handleSizeChange" />
      </div>
    </div>

    <el-dialog
      :visible.sync="addDialogVisible"
      width="610px"
      :title="dialogMode === 'add' ? '添加题目' : '编辑题目'"
      :close-on-click-modal="false"
      :show-close="false"
      custom-class="figma-topic-dialog"
    >
      <el-form class="topic-dialog-form" label-width="60px">
        <el-form-item :label="$t('committeeQuestionnaireTopic.form.community') + ':'" required>
          <el-select v-model="addForm.communityId" filterable style="width:100%" placeholder="请选择">
            <el-option v-for="c in myCommunities" :key="c.communityId" :label="c.name" :value="c.communityId" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('committeeQuestionnaireTopic.form.name') + ':'" required>
          <el-input v-model="addForm.name" placeholder="请输入" />
        </el-form-item>
        <el-form-item :label="$t('committeeQuestionnaireTopic.form.type') + ':'" required>
          <el-select v-model="addForm.type" style="width:100%" @change="handleTypeChange">
            <el-option label="单选" value="1001" />
            <el-option label="多选" value="2002" />
            <el-option label="简答" value="3003" />
          </el-select>
        </el-form-item>
        <template v-if="addForm.type !== '3003'">
          <el-form-item v-for="(opt, idx) in addForm.options" :key="idx" :label="`${$t('committeeQuestionnaireTopic.form.option')}${idx + 1}:`" required class="topic-option-form-item">
            <div class="topic-option-row">
              <el-input v-model="opt.value" placeholder="请输入" />
              <el-button class="option-delete-btn" icon="el-icon-delete" @click="removeOption(idx)" />
            </div>
          </el-form-item>
          <div class="topic-add-option-wrap">
            <el-button class="add-option-btn" type="text" @click="addOption">+ {{ $t('committeeQuestionnaireTopic.form.addOption') }}</el-button>
          </div>
        </template>
      </el-form>
      <span slot="footer" class="topic-dialog-footer">
        <el-button class="topic-cancel-btn" @click="addDialogVisible = false">{{ $t('committeeQuestionnaireTopic.dialog.cancel') }}</el-button>
        <el-button class="topic-confirm-btn" type="primary" :loading="addSubmitting" @click="submitTopicForm">{{ $t('committeeQuestionnaireTopic.dialog.confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getCommunityId, getCommunityName } from '@/api/community/communityApi'
import { listCommunitysByOwnerCommittee } from '@/api/owner/ownerCommitteeManageApi'
import { listQuestionnaireTopics, saveQuestionnaireTopic, updateQuestionnaireTopic, deleteQuestionnaireTopic } from '@/api/committee/questionnaireTopicApi'

export default {
  name: 'CommitteeQuestionnaireTopicList',
  data() {
    return {
      loading: false,
      conditions: { keyword: '' },
      tableData: [],
      pagination: { total: 0, page: 1, row: 10 },
      addDialogVisible: false,
      addSubmitting: false,
      dialogMode: 'add',
      addForm: this.getDefaultForm(),
      myCommunities: []
    }
  },
  created() {
    this.loadCommunities().then(() => {
      this.getList()
    })
  },
  methods: {
    headerCellStyle() { return { background: '#EBF2FA', color: '#364153', fontWeight: 500, fontSize: '14px', height: '50px' } },
    cellStyle({ rowIndex }) { return { fontSize: '14px', fontWeight: 500, background: rowIndex % 2 === 1 ? '#F8FBFF' : '#FFFFFF', height: '50px' } },
    getDefaultForm() {
      return { titleId: '', communityId: '', name: '', type: '2002', required: 'Y', options: [{ value: '' }, { value: '' }] }
    },
    isSuccess(res) {
      return res && (res.code === 0 || res.code === 200 || res.code === '0' || res.code === '200' || res.success || res.msg === 'success')
    },
    getListArray(res) {
      if (Array.isArray(res)) return res
      if (Array.isArray(res && res.data)) return res.data
      if (Array.isArray(res && res.records)) return res.records
      if (Array.isArray(res && res.rows)) return res.rows
      if (Array.isArray(res && res.questionTitles)) return res.questionTitles
      return []
    },
    getTotal(res, list) {
      return Number((res && (res.total || res.count || res.totalCount)) || list.length || 0)
    },
    getTypeName(type) {
      if (type === '1001') return '单选'
      if (type === '2002') return '多选'
      return '简答题'
    },
    getOptionsText(values) {
      const list = Array.isArray(values) ? values : []
      if (!list.length) return '-'
      return list.map((item, index) => `${item.seq || index + 1}.${item.qaValue || item.itemValue || ''}`).join('  ')
    },
    normalizeTopic(row) {
      let communityName = row.communityName
      try { communityName = communityName || getCommunityName() } catch (e) { communityName = row.communityName || '' }

      return {
        ...row,
        _raw: row,
        titleId: row.titleId || row.id,
        communityName,
        topicName: row.qaTitle || row.topicName || row.itemTitle || '',
        topicTypeName: this.getTypeName(row.titleType),
        optionsText: this.getOptionsText(row.titleValues),
        createTime: row.createTime || ''
      }
    },
    async getList() {
      try {
        this.loading = true
        const res = await listQuestionnaireTopics({
          page: this.pagination.page,
          row: this.pagination.row,
          qaTitle: this.conditions.keyword,
          communityIds: this.myCommunities.map(c => c.communityId)
        })
        const list = this.getListArray(res)
        this.tableData = list.map(item => this.normalizeTopic(item))

        this.pagination.total = this.getTotal(res, list)
      } catch (e) {
        this.$message.error('获取数据失败')
      } finally {
        this.loading = false
      }
    },
    handleSearch() { this.pagination.page = 1; this.getList() },
    async loadCommunities() {
      try {
        const res = await listCommunitysByOwnerCommittee({ page: 1, row: 1000 })
        this.myCommunities = res.data || []
      } catch (e) {
        this.myCommunities = []
      }
    },
    async handleAdd() {
      this.dialogMode = 'add'
      this.addForm = this.getDefaultForm()
      await this.loadCommunities()
      this.addDialogVisible = true
    },
    async handleEdit(row) {
      this.dialogMode = 'edit'
      await this.loadCommunities()
      const raw = row._raw || row
      this.addForm = {
        titleId: raw.titleId || row.titleId,
        communityId: raw.communityId || getCommunityId(),
        name: raw.qaTitle || row.topicName,
        type: raw.titleType || '1001',
        required: raw.required || 'Y',
        options: (raw.titleValues || []).map(item => ({ value: item.qaValue || item.itemValue || '' }))
      }
      if (!this.addForm.options.length) this.addForm.options = [{ value: '' }, { value: '' }]
      this.addDialogVisible = true
    },
    handleTypeChange(type) {
      if (type === '3003') return
      if (!this.addForm.options.length) this.addForm.options = [{ value: '' }, { value: '' }]
    },
    addOption() { this.addForm.options.push({ value: '' }) },
    removeOption(idx) {
      if (this.addForm.options.length <= 1) return
      this.addForm.options.splice(idx, 1)
    },
    validateForm() {
      if (!this.addForm.communityId) return this.$message.warning('请选择小区'), false
      if (!this.addForm.name) return this.$message.warning('请输入名称'), false
      if (!this.addForm.type) return this.$message.warning('请选择类型'), false
      if (this.addForm.type !== '3003' && !this.addForm.options.some(item => item.value)) return this.$message.warning('请输入选项'), false
      return true
    },
    buildPayload() {
      const titleValues = this.addForm.type === '3003' ? [] : this.addForm.options
        .map((item, index) => ({ seq: index + 1, itemValue: (item.value || '').trim(), qaValue: (item.value || '').trim() }))
        .filter(item => item.itemValue)
      return {
        titleId: this.addForm.titleId,
        communityId: this.addForm.communityId,
        qaTitle: this.addForm.name,
        titleType: this.addForm.type,
        required: this.addForm.required,
        titleValues
      }
    },
    async submitTopicForm() {
      if (!this.validateForm()) return
      try {
        this.addSubmitting = true
        const api = this.dialogMode === 'edit' ? updateQuestionnaireTopic : saveQuestionnaireTopic
        const res = await api(this.buildPayload())
        if (!this.isSuccess(res)) throw new Error((res && res.msg) || '保存失败')
        this.$message.success('保存成功')
        this.addDialogVisible = false
        this.getList()
      } catch (e) {
        this.$message.error(e.message || '保存失败')
      } finally {
        this.addSubmitting = false
      }
    },
    handleDelete(row) {
      this.$confirm(this.$t('committeeQuestionnaireTopic.dialog.deleteConfirm'), this.$t('committeeQuestionnaireTopic.dialog.deleteTitle'), { type: 'warning' }).then(async () => {
        const res = await deleteQuestionnaireTopic({ titleId: row.titleId })
        if (!this.isSuccess(res)) throw new Error((res && res.msg) || '删除失败')
        this.$message.success(this.$t('committeeQuestionnaireTopic.dialog.deleteSuccess'))
        this.getList()
      }).catch(e => {
        if (e && e.message) this.$message.error(e.message)
      })
    },
    handlePageChange(page) { this.pagination.page = page; this.getList() },
    handleSizeChange(size) { this.pagination.row = size; this.pagination.page = 1; this.getList() }
  }
}
</script>

<style scoped>
.admin-room-container { height: calc(100vh - 60px); background: #EBF2FA; padding: 0; overflow: hidden; box-sizing: border-box; display: flex; flex-direction: column; }
.figma-white-card { background: white; border-radius: 0 0 12px 12px; flex: 1; min-height: 0; display: flex; flex-direction: column; }
.figma-page-header { display: flex; flex-direction: column; align-items: flex-start; padding: 20px 24px 12px; gap: 12px; flex-shrink: 0; text-align: left; }
.figma-page-title { font-size: 16px; font-weight: 600; color: #1D2129; font-family: 'PingFang SC'; line-height: 22px; text-align: left; }
.figma-header-divider { width: 100%; height: 1px; background: #DCE6F5; }
.figma-header-row { display: flex; align-items: center; justify-content: space-between; width: 100%; }
.figma-btn-group { display: flex; gap: 12px; }
.figma-btn-add { width: 82px; height: 38px; background: #0E76FF !important; border-color: #0E76FF !important; color: white !important; border-radius: 10px !important; }
.figma-btn-refresh { width: 38px; height: 38px; padding: 0 !important; background: white !important; border-color: #DCE6F5 !important; color: #364153 !important; border-radius: 10px !important; }
.figma-search-group { display: flex; gap: 12px; align-items: center; }
.figma-search-input { width: 256px; }
.figma-btn-search { width: 84px; height: 38px; background: white !important; border-color: #0E76FF !important; color: #0E76FF !important; border-radius: 10px !important; }
.figma-table-section { flex: 1; min-height: 0; padding: 12px 24px 0; overflow: auto; }
.figma-pagination-section { display: flex; justify-content: flex-end; padding: 16px 24px 24px; flex-shrink: 0; }
.action-links { display: flex; align-items: center; justify-content: center; gap: 8px; }
.delete-btn { color: #F56C6C !important; }
.option-row { display: flex; gap: 8px; margin-bottom: 10px; align-items: center; }
.add-option-btn { color: #0E76FF !important; }
.figma-property-page ::v-deep .el-input__inner { height: 38px; line-height: 38px; border-radius: 10px; border-color: #DCE6F5; }
.figma-property-page ::v-deep .el-button { font-size: 14px; font-weight: 500; }
.figma-property-page ::v-deep .el-table th, .figma-property-page ::v-deep .el-table td { padding: 0; }
.figma-property-page ::v-deep .el-table::before { display: none; }

/* 添加/编辑题目弹窗 */
.figma-property-page ::v-deep .figma-topic-dialog { border-radius: 8px; overflow: hidden; }
.figma-property-page ::v-deep .figma-topic-dialog .el-dialog__header { height: 58px; padding: 18px 20px; box-sizing: border-box; background: #EBF2FA; border-bottom: 1px solid #DCE6F5; text-align: left; }
.figma-property-page ::v-deep .figma-topic-dialog .el-dialog__title { font-size: 14px; line-height: 20px; font-weight: 600; color: #1D2129; }
.figma-property-page ::v-deep .figma-topic-dialog .el-dialog__headerbtn { top: 18px; right: 18px; }
.figma-property-page ::v-deep .figma-topic-dialog .el-dialog__body { flex: 1; padding: 16px 24px 8px 28px; box-sizing: border-box; overflow: hidden; }
.figma-property-page ::v-deep .figma-topic-dialog .el-dialog__footer { padding: 8px 24px 20px; flex-shrink: 0; }
.topic-dialog-form ::v-deep .el-form-item { margin-bottom: 16px; }
.topic-dialog-form ::v-deep .el-form-item__label { height: 38px; line-height: 38px; padding: 0 12px 0 0; font-size: 14px; font-weight: 400; color: #1D2129; text-align: right; white-space: nowrap; overflow: visible; }
.topic-dialog-form ::v-deep .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before { color: #F53F3F; margin-right: 3px; }
.topic-dialog-form ::v-deep .el-form-item__content { line-height: 38px; }
.topic-dialog-form ::v-deep .el-input__inner { height: 38px; line-height: 38px; border-radius: 10px; border: 1px solid #DCE6F5; padding: 0 28px 0 12px; font-size: 14px; color: #1D2129; }
.topic-dialog-form ::v-deep .el-input__inner::placeholder { color: #A8B3C7; }
.topic-dialog-form ::v-deep .el-select .el-input .el-select__caret { line-height: 38px; color: #0E76FF; }
.topic-option-row { display: flex; align-items: center; gap: 8px; }
.topic-option-row .el-input { flex: 1; }
.option-delete-btn { width: 32px; height: 38px; padding: 0 !important; border: none !important; background: transparent !important; color: #8C9BB4 !important; }
.option-delete-btn:hover { color: #0E76FF !important; }
.topic-add-option-wrap { margin-left: 60px; }
.topic-add-option-wrap .add-option-btn { width: 100%; height: 28px; padding: 0 !important; border: 1px dashed #0E76FF !important; border-radius: 2px !important; color: #0E76FF !important; background: white !important; font-size: 12px; font-weight: 500; }
.topic-dialog-footer { display: flex; justify-content: flex-end; gap: 12px; }
.topic-cancel-btn,
.topic-confirm-btn { min-width: 76px; height: 32px; padding: 0 18px !important; border-radius: 6px !important; font-size: 12px !important; }
.topic-cancel-btn { color: #0E76FF !important; border-color: #0E76FF !important; background: white !important; }
.topic-confirm-btn { color: white !important; border-color: #0E76FF !important; background: #0E76FF !important; }
</style>
